export * from './progress-circle';
export * from './progress-spinner';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/progress-spinner/index.js
// module id = 711
// module chunks = 3